import React from 'react';
import PropTypes from 'prop-types';
import SlickWrapper from 'epic-react-common/src/components/SlickWrapper';
import CarouselItem from './CarouselItem';

export default class Carousel extends React.PureComponent {
    static propTypes = {
        news: PropTypes.bool,
        refFunction: PropTypes.func
    };
    render() {
        const {news, refFunction} = this.props;
        const title = news ? 'News' : 'Gallery';
        const carouselItems = [];
        const slidesShow = news ? 3 : 2;
        const variableWidth = news;
        for (let i = 0; i < 8; i++) {
            const key = `${title}-${i}`;
            carouselItems.push(<CarouselItem key={key} number={key} title={news} />);
        }

        const sliderOptions = {
            infinite: false,
            speed: 700,
            draggable: true,
            touchMove: true,
            focusOnSelect: true,
            variableWidth,
            slidesToShow: slidesShow,
            slidesToScroll: 1,
            dots: true,
            dotsClass: 'carousel-pag',
            responsive: [{breakpoint: 568, settings: {variableWidth: false, slidesToShow: 1}}]
        };
        return (
            <div className="carousel">
                <h1>{title}</h1>
                <div className="carousel-container">
                    <SlickWrapper ref={refFunction} options={sliderOptions}>
                        {carouselItems}
                    </SlickWrapper>
                </div>
            </div>
        );
    }
}

